import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  TextField,
  InputAdornment,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Card,
  CardContent,
  CardActions,
  Tabs,
  Tab,
  Badge,
  Avatar,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Divider,
  Alert,
  CircularProgress,
  Tooltip,
  Fab,
  Slider,
  LinearProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Switch,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormLabel
} from '@mui/material';
import {
  Search as SearchIcon,
  FilterList as FilterIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  Message as MessageIcon,
  Visibility as ViewIcon,
  PlayArrow as PlayIcon,
  Pause as PauseIcon,
  Stop as StopIcon,
  VolumeUp as VolumeIcon,
  Add as AddIcon,
  Refresh as RefreshIcon,
  Assignment as AssignmentIcon,
  LocalShipping as ShippingIcon,
  Payment as PaymentIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Pending as PendingIcon,
  Warning as WarningIcon,
  TrendingUp as TrendingUpIcon,
  People as PeopleIcon,
  ShoppingCart as CartIcon,
  AttachMoney as MoneyIcon,
  Schedule as ScheduleIcon,
  LocationOn as LocationIcon,
  Store as StoreIcon,
  Mic as MicIcon,
  Headphones as HeadphonesIcon,
  RecordVoiceOver as RecordIcon,
  ExpandMore as ExpandMoreIcon,
  PersonAdd as PersonAddIcon,
  Save as SaveIcon,
  Send as SendIcon,
  Download as DownloadIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Close as CloseIcon,
  Check as CheckIcon,
  Error as ErrorIcon,
  Info as InfoIcon,
  Timer as TimerIcon,
  Speed as SpeedIcon,
  Repeat as RepeatIcon,
  SkipNext as SkipNextIcon,
  SkipPrevious as SkipPreviousIcon
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import AsteriskCallManager from '../../components/call/AsteriskCallManager';

// Styled components
const StatusChip = styled(Chip)(({ theme, status }) => ({
  fontWeight: 600,
  ...(status === 'pending' && {
    backgroundColor: '#fff3cd',
    color: '#856404',
    border: '1px solid #ffeaa7'
  }),
  ...(status === 'processing' && {
    backgroundColor: '#cce5ff',
    color: '#004085',
    border: '1px solid #b3d9ff'
  }),
  ...(status === 'completed' && {
    backgroundColor: '#d4edda',
    color: '#155724',
    border: '1px solid #c3e6cb'
  }),
  ...(status === 'cancelled' && {
    backgroundColor: '#f8d7da',
    color: '#721c24',
    border: '1px solid #f5c6cb'
  }),
  ...(status === 'transcribed' && {
    backgroundColor: '#d1ecf1',
    color: '#0c5460',
    border: '1px solid #bee5eb'
  })
}));

const PriorityChip = styled(Chip)(({ theme, priority }) => ({
  fontWeight: 600,
  ...(priority === 'high' && {
    backgroundColor: '#f8d7da',
    color: '#721c24'
  }),
  ...(priority === 'medium' && {
    backgroundColor: '#fff3cd',
    color: '#856404'
  }),
  ...(priority === 'low' && {
    backgroundColor: '#d1ecf1',
    color: '#0c5460'
  })
}));

const AudioPlayer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(2),
  backgroundColor: '#f8f9fa',
  borderRadius: theme.spacing(1),
  border: '1px solid #e9ecef'
}));

const VoiceOrder = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [priorityFilter, setPriorityFilter] = useState('all');
  const [selectedVoiceOrder, setSelectedVoiceOrder] = useState(null);
  const [voiceOrderDetailDialog, setVoiceOrderDetailDialog] = useState(false);
  const [transcriptionDialog, setTranscriptionDialog] = useState(false);
  const [orderPlacementDialog, setOrderPlacementDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [audioPlaying, setAudioPlaying] = useState(null);
  const [audioProgress, setAudioProgress] = useState(0);
  const [audioDuration, setAudioDuration] = useState(0);
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [volume, setVolume] = useState(80);

  // Mock data for voice orders
  const [voiceOrders, setVoiceOrders] = useState([
    {
      id: 'VO-001',
      customerName: 'রহিম উদ্দিন',
      customerPhone: '01712345678',
      customerEmail: 'rahim@email.com',
      deliveryAddress: 'হাউস নং ১২৩, রোড নং ৪, মোহাম্মদপুর, ঢাকা',
      orderDate: '2024-01-15T10:30:00',
      status: 'pending',
      priority: 'high',
      audioDuration: 45, // seconds
      audioUrl: '/api/voice-orders/audio/vo-001.mp3',
      transcription: '',
      isTranscribed: false,
      isCustomerLoggedIn: true,
      customerId: 'CUST-001',
      notes: 'গ্রাহক চাল, ডাল, তেল এবং সবজি চেয়েছেন',
      assignedTo: null,
      estimatedOrderValue: 1500
    },
    {
      id: 'VO-002',
      customerName: 'ফাতেমা খাতুন',
      customerPhone: '01823456789',
      customerEmail: 'fatema@email.com',
      deliveryAddress: 'ফ্ল্যাট নং ৫৬, বিল্ডিং নং ৭, উত্তরা, ঢাকা',
      orderDate: '2024-01-15T09:15:00',
      status: 'processing',
      priority: 'medium',
      audioDuration: 32,
      audioUrl: '/api/voice-orders/audio/vo-002.mp3',
      transcription: 'আমি চাই: ২ কেজি চাল, ১ কেজি ডাল, ১ লিটার তেল, ৫০০ গ্রাম মসলা',
      isTranscribed: true,
      isCustomerLoggedIn: false,
      customerId: null,
      notes: 'গ্রাহক স্পষ্টভাবে পণ্যগুলি বলেছেন',
      assignedTo: 'SUPPORT-001',
      estimatedOrderValue: 1200
    },
    {
      id: 'VO-003',
      customerName: 'করিম মিয়া',
      customerPhone: '01934567890',
      customerEmail: 'karim@email.com',
      deliveryAddress: 'হাউস নং ৭৮৯, রোড নং ১২, মিরপুর, ঢাকা',
      orderDate: '2024-01-15T08:45:00',
      status: 'transcribed',
      priority: 'low',
      audioDuration: 28,
      audioUrl: '/api/voice-orders/audio/vo-003.mp3',
      transcription: 'আমার জন্য কিনুন: ১ কেজি আলু, ৫০০ গ্রাম পেঁয়াজ, ২৫০ গ্রাম আদা, ১ কেজি টমেটো',
      isTranscribed: true,
      isCustomerLoggedIn: true,
      customerId: 'CUST-003',
      notes: 'গ্রাহক সবজি চেয়েছেন',
      assignedTo: 'SUPPORT-002',
      estimatedOrderValue: 800
    },
    {
      id: 'VO-004',
      customerName: 'সালমা বেগম',
      customerPhone: '01645678901',
      customerEmail: 'salma@email.com',
      deliveryAddress: 'ফ্ল্যাট নং ৩৪৫, বিল্ডিং নং ১০, গুলশান, ঢাকা',
      orderDate: '2024-01-15T07:30:00',
      status: 'completed',
      priority: 'medium',
      audioDuration: 55,
      audioUrl: '/api/voice-orders/audio/vo-004.mp3',
      transcription: 'আমি চাই: ৩ কেজি চাল, ২ কেজি ডাল, ২ লিটার তেল, ১ কেজি চিনি, ৫০০ গ্রাম চা পাতা',
      isTranscribed: true,
      isCustomerLoggedIn: false,
      customerId: null,
      notes: 'অর্ডার সফলভাবে সম্পন্ন হয়েছে',
      assignedTo: 'SUPPORT-001',
      estimatedOrderValue: 2500
    },
    {
      id: 'VO-005',
      customerName: 'আব্দুল্লাহ আল মামুন',
      customerPhone: '01556789012',
      customerEmail: 'mamun@email.com',
      deliveryAddress: 'হাউস নং ২৩৪, রোড নং ৮, বনানী, ঢাকা',
      orderDate: '2024-01-15T06:20:00',
      status: 'cancelled',
      priority: 'high',
      audioDuration: 40,
      audioUrl: '/api/voice-orders/audio/vo-005.mp3',
      transcription: '',
      isTranscribed: false,
      isCustomerLoggedIn: true,
      customerId: 'CUST-005',
      notes: 'গ্রাহক অর্ডার বাতিল করেছেন',
      assignedTo: null,
      estimatedOrderValue: 1800
    }
  ]);

  const [filteredVoiceOrders, setFilteredVoiceOrders] = useState(voiceOrders);

  // Filter voice orders based on search and filters
  useEffect(() => {
    let filtered = voiceOrders;

    // Search filter
    if (searchQuery) {
      filtered = filtered.filter(order =>
        order.id.toLowerCase().includes(searchQuery.toLowerCase()) ||
        order.customerName.toLowerCase().includes(searchQuery.toLowerCase()) ||
        order.customerPhone.includes(searchQuery) ||
        order.transcription.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Status filter
    if (statusFilter !== 'all') {
      filtered = filtered.filter(order => order.status === statusFilter);
    }

    // Priority filter
    if (priorityFilter !== 'all') {
      filtered = filtered.filter(order => order.priority === priorityFilter);
    }

    setFilteredVoiceOrders(filtered);
  }, [searchQuery, statusFilter, priorityFilter, voiceOrders]);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const handleVoiceOrderClick = (order) => {
    setSelectedVoiceOrder(order);
    setVoiceOrderDetailDialog(true);
  };

  const handleTranscriptionClick = (order) => {
    setSelectedVoiceOrder(order);
    setTranscriptionDialog(true);
  };

  const handleOrderPlacementClick = (order) => {
    setSelectedVoiceOrder(order);
    setOrderPlacementDialog(true);
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'pending': return <PendingIcon />;
      case 'processing': return <AssignmentIcon />;
      case 'transcribed': return <CheckCircleIcon />;
      case 'completed': return <CheckCircleIcon />;
      case 'cancelled': return <CancelIcon />;
      default: return <PendingIcon />;
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'pending': return 'পেন্ডিং';
      case 'processing': return 'প্রসেসিং';
      case 'transcribed': return 'ট্রান্সক্রাইবড';
      case 'completed': return 'সম্পন্ন';
      case 'cancelled': return 'বাতিল';
      default: return 'অজানা';
    }
  };

  const getPriorityText = (priority) => {
    switch (priority) {
      case 'high': return 'উচ্চ';
      case 'medium': return 'মাঝারি';
      case 'low': return 'নিম্ন';
      default: return 'অজানা';
    }
  };

  const handleRefresh = () => {
    setLoading(true);
    // Simulate API call
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const handlePlayAudio = (orderId) => {
    setAudioPlaying(audioPlaying === orderId ? null : orderId);
    // Simulate audio playback
    if (audioPlaying !== orderId) {
      setAudioProgress(0);
      setAudioDuration(voiceOrders.find(o => o.id === orderId)?.audioDuration || 0);
    }
  };

  const handleCallCustomer = (phone) => {
    // Dispatch outgoing call event to trigger dialing popup
    window.dispatchEvent(new CustomEvent('make-outgoing-call', {
      detail: { number: phone }
    }));
  };

  const handleEmailCustomer = (email) => {
    // Implement email functionality
    window.open(`mailto:${email}`, '_blank');
  };

  const handleMessageCustomer = (phone) => {
    // Implement messaging functionality
    console.log('Messaging customer:', phone);
  };

  const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const formatDateTime = (dateTime) => {
    return new Date(dateTime).toLocaleString('bn-BD', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <Box>
      {/* Asterisk Call Manager */}
      <AsteriskCallManager 
        customerDatabase={voiceOrders.map(order => ({
          id: order.customerId || `CUST-${order.id}`,
          name: order.customerName,
          phone: order.customerPhone,
          email: order.customerEmail,
          address: order.deliveryAddress
        }))}
        onCustomerFound={(customer) => {
          console.log('Customer found during call:', customer);
        }}
      />

      {/* Header */}
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          ভয়েস অর্ডার
        </Typography>
        <Button
          variant="contained"
          startIcon={<RefreshIcon />}
          onClick={handleRefresh}
          disabled={loading}
        >
          {loading ? <CircularProgress size={20} /> : 'রিফ্রেশ'}
        </Button>
      </Box>

      {/* Stats Cards */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <MicIcon sx={{ fontSize: 40, color: '#1976d2', mr: 2 }} />
                <Box>
                  <Typography variant="h4" component="div">
                    {voiceOrders.filter(o => o.status === 'pending').length}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    নতুন ভয়েস অর্ডার
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <HeadphonesIcon sx={{ fontSize: 40, color: '#2e7d32', mr: 2 }} />
                <Box>
                  <Typography variant="h4" component="div">
                    {voiceOrders.filter(o => o.status === 'processing').length}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    প্রসেসিং
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <CheckCircleIcon sx={{ fontSize: 40, color: '#ed6c02', mr: 2 }} />
                <Box>
                  <Typography variant="h4" component="div">
                    {voiceOrders.filter(o => o.status === 'completed').length}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    সম্পন্ন
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <WarningIcon sx={{ fontSize: 40, color: '#d32f2f', mr: 2 }} />
                <Box>
                  <Typography variant="h4" component="div">
                    {voiceOrders.filter(o => o.priority === 'high').length}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    উচ্চ প্রাধান্য
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Tabs */}
      <Paper sx={{ mb: 3 }}>
        <Tabs value={currentTab} onChange={handleTabChange} sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tab label="সকল অর্ডার" />
          <Tab label="নতুন" />
          <Tab label="প্রসেসিং" />
          <Tab label="ট্রান্সক্রাইবড" />
          <Tab label="সম্পন্ন" />
        </Tabs>
      </Paper>

      {/* Search and Filters */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              placeholder="অর্ডার আইডি, গ্রাহকের নাম, ফোন নম্বর বা ট্রান্সক্রিপশন খুঁজুন..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel>স্ট্যাটাস</InputLabel>
              <Select
                value={statusFilter}
                label="স্ট্যাটাস"
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <MenuItem value="all">সকল</MenuItem>
                <MenuItem value="pending">পেন্ডিং</MenuItem>
                <MenuItem value="processing">প্রসেসিং</MenuItem>
                <MenuItem value="transcribed">ট্রান্সক্রাইবড</MenuItem>
                <MenuItem value="completed">সম্পন্ন</MenuItem>
                <MenuItem value="cancelled">বাতিল</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel>প্রাধান্য</InputLabel>
              <Select
                value={priorityFilter}
                label="প্রাধান্য"
                onChange={(e) => setPriorityFilter(e.target.value)}
              >
                <MenuItem value="all">সকল</MenuItem>
                <MenuItem value="high">উচ্চ</MenuItem>
                <MenuItem value="medium">মাঝারি</MenuItem>
                <MenuItem value="low">নিম্ন</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={2}>
            <Button
              fullWidth
              variant="outlined"
              startIcon={<FilterIcon />}
              onClick={() => {
                setSearchQuery('');
                setStatusFilter('all');
                setPriorityFilter('all');
              }}
            >
              রিসেট
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {/* Voice Orders Table */}
      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>অর্ডার আইডি</TableCell>
                <TableCell>গ্রাহক</TableCell>
                <TableCell>অডিও</TableCell>
                <TableCell>ট্রান্সক্রিপশন</TableCell>
                <TableCell>তারিখ</TableCell>
                <TableCell>স্ট্যাটাস</TableCell>
                <TableCell>প্রাধান্য</TableCell>
                <TableCell>অ্যাকশন</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredVoiceOrders.map((order) => (
                <TableRow key={order.id} hover>
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight="bold">
                      {order.id}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Box>
                      <Typography variant="subtitle2" fontWeight="bold">
                        {order.customerName}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {order.customerPhone}
                      </Typography>
                      <Chip
                        size="small"
                        label={order.isCustomerLoggedIn ? 'লগইন' : 'অতিথি'}
                        color={order.isCustomerLoggedIn ? 'success' : 'default'}
                        sx={{ mt: 0.5 }}
                      />
                    </Box>
                  </TableCell>
                  <TableCell>
                    <AudioPlayer>
                      <IconButton
                        size="small"
                        onClick={() => handlePlayAudio(order.id)}
                        color="primary"
                      >
                        {audioPlaying === order.id ? <PauseIcon /> : <PlayIcon />}
                      </IconButton>
                      <Box sx={{ flexGrow: 1 }}>
                        <Typography variant="caption" display="block">
                          {formatDuration(order.audioDuration)}
                        </Typography>
                        {audioPlaying === order.id && (
                          <LinearProgress
                            variant="determinate"
                            value={(audioProgress / audioDuration) * 100}
                            sx={{ mt: 0.5 }}
                          />
                        )}
                      </Box>
                      <IconButton size="small">
                        <VolumeIcon />
                      </IconButton>
                    </AudioPlayer>
                  </TableCell>
                  <TableCell>
                    <Box>
                      {order.isTranscribed ? (
                        <Typography variant="body2" sx={{ maxWidth: 200 }}>
                          {order.transcription.substring(0, 100)}...
                        </Typography>
                      ) : (
                        <Chip
                          size="small"
                          label="ট্রান্সক্রাইব করা হয়নি"
                          color="warning"
                        />
                      )}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">
                      {formatDateTime(order.orderDate)}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <StatusChip
                      icon={getStatusIcon(order.status)}
                      label={getStatusText(order.status)}
                      status={order.status}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    <PriorityChip
                      label={getPriorityText(order.priority)}
                      priority={order.priority}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <Tooltip title="অর্ডার দেখুন">
                        <IconButton
                          size="small"
                          onClick={() => handleVoiceOrderClick(order)}
                        >
                          <ViewIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="ট্রান্সক্রিপশন">
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={() => handleTranscriptionClick(order)}
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="অর্ডার প্লেস করুন">
                        <IconButton
                          size="small"
                          color="success"
                          onClick={() => handleOrderPlacementClick(order)}
                        >
                          <CartIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="কল করুন">
                        <IconButton
                          size="small"
                          color="info"
                          onClick={() => handleCallCustomer(order.customerPhone)}
                        >
                          <PhoneIcon />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* Voice Order Detail Dialog */}
      <Dialog
        open={voiceOrderDetailDialog}
        onClose={() => setVoiceOrderDetailDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          ভয়েস অর্ডার বিবরণ - {selectedVoiceOrder?.id}
        </DialogTitle>
        <DialogContent>
          {selectedVoiceOrder && (
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Typography variant="h6" gutterBottom>গ্রাহকের তথ্য</Typography>
                <List>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <PeopleIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={selectedVoiceOrder.customerName}
                      secondary={`ফোন: ${selectedVoiceOrder.customerPhone}`}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="ইমেইল"
                      secondary={selectedVoiceOrder.customerEmail}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="ডেলিভারি ঠিকানা"
                      secondary={selectedVoiceOrder.deliveryAddress}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="অ্যাকাউন্ট স্ট্যাটাস"
                      secondary={
                        <Chip
                          size="small"
                          label={selectedVoiceOrder.isCustomerLoggedIn ? 'লগইন ইউজার' : 'অতিথি ইউজার'}
                          color={selectedVoiceOrder.isCustomerLoggedIn ? 'success' : 'default'}
                        />
                      }
                    />
                  </ListItem>
                </List>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="h6" gutterBottom>অডিও তথ্য</Typography>
                <AudioPlayer>
                  <IconButton
                    size="large"
                    onClick={() => handlePlayAudio(selectedVoiceOrder.id)}
                    color="primary"
                  >
                    {audioPlaying === selectedVoiceOrder.id ? <PauseIcon /> : <PlayIcon />}
                  </IconButton>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="subtitle2">
                      অডিও ডিউরেশন: {formatDuration(selectedVoiceOrder.audioDuration)}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      রেকর্ডিং তারিখ: {formatDateTime(selectedVoiceOrder.orderDate)}
                    </Typography>
                  </Box>
                </AudioPlayer>
                
                <Box sx={{ mt: 2 }}>
                  <Typography variant="h6" gutterBottom>ট্রান্সক্রিপশন</Typography>
                  {selectedVoiceOrder.isTranscribed ? (
                    <Alert severity="success">
                      <Typography variant="body2">
                        {selectedVoiceOrder.transcription}
                      </Typography>
                    </Alert>
                  ) : (
                    <Alert severity="warning">
                      <Typography variant="body2">
                        ট্রান্সক্রিপশন এখনও সম্পন্ন হয়নি
                      </Typography>
                    </Alert>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>নোটস</Typography>
                <Alert severity="info">
                  <Typography variant="body2">
                    {selectedVoiceOrder.notes}
                  </Typography>
                </Alert>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setVoiceOrderDetailDialog(false)}>বন্ধ করুন</Button>
          <Button
            variant="contained"
            onClick={() => {
              setVoiceOrderDetailDialog(false);
              setTranscriptionDialog(true);
            }}
          >
            ট্রান্সক্রাইব করুন
          </Button>
        </DialogActions>
      </Dialog>

      {/* Transcription Dialog */}
      <Dialog
        open={transcriptionDialog}
        onClose={() => setTranscriptionDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          ট্রান্সক্রিপশন - {selectedVoiceOrder?.id}
        </DialogTitle>
        <DialogContent>
          {selectedVoiceOrder && (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>অডিও প্লেয়ার</Typography>
                <AudioPlayer>
                  <IconButton
                    size="large"
                    onClick={() => handlePlayAudio(selectedVoiceOrder.id)}
                    color="primary"
                  >
                    {audioPlaying === selectedVoiceOrder.id ? <PauseIcon /> : <PlayIcon />}
                  </IconButton>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="subtitle2">
                      {formatDuration(selectedVoiceOrder.audioDuration)}
                    </Typography>
                    <Slider
                      value={audioProgress}
                      max={audioDuration}
                      onChange={(e, value) => setAudioProgress(value)}
                      sx={{ mt: 1 }}
                    />
                  </Box>
                  <FormControl size="small" sx={{ minWidth: 100 }}>
                    <Select
                      value={playbackSpeed}
                      onChange={(e) => setPlaybackSpeed(e.target.value)}
                    >
                      <MenuItem value={0.5}>0.5x</MenuItem>
                      <MenuItem value={0.75}>0.75x</MenuItem>
                      <MenuItem value={1}>1x</MenuItem>
                      <MenuItem value={1.25}>1.25x</MenuItem>
                      <MenuItem value={1.5}>1.5x</MenuItem>
                      <MenuItem value={2}>2x</MenuItem>
                    </Select>
                  </FormControl>
                </AudioPlayer>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>ট্রান্সক্রিপশন</Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={6}
                  placeholder="এখানে অডিও থেকে শোনা পণ্যগুলি লিখুন..."
                  defaultValue={selectedVoiceOrder.transcription}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>পণ্য তালিকা</Typography>
                <Alert severity="info">
                  <Typography variant="body2">
                    ট্রান্সক্রিপশন থেকে পণ্যগুলি সনাক্ত করুন এবং অর্ডার প্লেসমেন্টের জন্য প্রস্তুত করুন।
                  </Typography>
                </Alert>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setTranscriptionDialog(false)}>বাতিল</Button>
          <Button
            variant="contained"
            onClick={() => {
              setTranscriptionDialog(false);
              setOrderPlacementDialog(true);
            }}
          >
            ট্রান্সক্রাইব সম্পন্ন করুন
          </Button>
        </DialogActions>
      </Dialog>

      {/* Order Placement Dialog */}
      <Dialog
        open={orderPlacementDialog}
        onClose={() => setOrderPlacementDialog(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          অর্ডার প্লেসমেন্ট - {selectedVoiceOrder?.id}
        </DialogTitle>
        <DialogContent>
          {selectedVoiceOrder && (
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Typography variant="h6" gutterBottom>গ্রাহক তথ্য</Typography>
                <List>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <PeopleIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={selectedVoiceOrder.customerName}
                      secondary={`ফোন: ${selectedVoiceOrder.customerPhone}`}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="ডেলিভারি ঠিকানা"
                      secondary={selectedVoiceOrder.deliveryAddress}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="অ্যাকাউন্ট স্ট্যাটাস"
                      secondary={
                        <Chip
                          size="small"
                          label={selectedVoiceOrder.isCustomerLoggedIn ? 'লগইন ইউজার' : 'অতিথি ইউজার'}
                          color={selectedVoiceOrder.isCustomerLoggedIn ? 'success' : 'default'}
                        />
                      }
                    />
                  </ListItem>
                </List>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="h6" gutterBottom>পণ্য নির্বাচন</Typography>
                <TextField
                  fullWidth
                  placeholder="পণ্য খুঁজুন..."
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ mb: 2 }}
                />
                <Box sx={{ maxHeight: 300, overflow: 'auto' }}>
                  <List>
                    <ListItem>
                      <ListItemText
                        primary="চাল - ২ কেজি"
                        secondary="৳120/কেজি"
                      />
                      <TextField
                        type="number"
                        size="small"
                        defaultValue="2"
                        sx={{ width: 80 }}
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemText
                        primary="ডাল - ১ কেজি"
                        secondary="৳180/কেজি"
                      />
                      <TextField
                        type="number"
                        size="small"
                        defaultValue="1"
                        sx={{ width: 80 }}
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemText
                        primary="তেল - ১ লিটার"
                        secondary="৳150/লিটার"
                      />
                      <TextField
                        type="number"
                        size="small"
                        defaultValue="1"
                        sx={{ width: 80 }}
                      />
                    </ListItem>
                  </List>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>অর্ডার সারসংক্ষেপ</Typography>
                <Card>
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Typography variant="body2">মোট পণ্য: ৪টি</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="body2">মোট মূল্য: ৳1,200</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="body2">ডেলিভারি চার্জ: ৳60</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="h6" color="primary">
                          মোট: ৳1,260
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              {!selectedVoiceOrder.isCustomerLoggedIn && (
                <Grid item xs={12}>
                  <Typography variant="h6" gutterBottom>গ্রাহক নোটিফিকেশন</Typography>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">গ্রাহককে কীভাবে জানাবেন?</FormLabel>
                    <RadioGroup defaultValue="sms">
                      <FormControlLabel value="sms" control={<Radio />} label="এসএমএস" />
                      <FormControlLabel value="call" control={<Radio />} label="কল" />
                      <FormControlLabel value="both" control={<Radio />} label="উভয়" />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              )}
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOrderPlacementDialog(false)}>বাতিল</Button>
          <Button
            variant="contained"
            color="success"
            startIcon={<SaveIcon />}
          >
            অর্ডার প্লেস করুন
          </Button>
        </DialogActions>
      </Dialog>

      {/* Floating Action Button */}
      <Fab
        color="primary"
        aria-label="নতুন ভয়েস অর্ডার"
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
        }}
      >
        <AddIcon />
      </Fab>
    </Box>
  );
};

export default VoiceOrder; 